import { useQuery } from '@tanstack/react-query'
import { getAnalysisUsage } from '@/api/requests/space'
import type { AnalysisUsageResponse } from '@/types/api/responses'

export function useFeatureUsage(
  spaceId: string | undefined,
  featureType: string = 'PROMPT_GENERATION'
) {
  return useQuery<AnalysisUsageResponse>({
    queryKey: ['featureUsage', spaceId, featureType],
    queryFn: () => {
      if (!spaceId) throw new Error('spaceId is required')
      return getAnalysisUsage(spaceId, featureType)
    },
    enabled: !!spaceId,
    staleTime: 5 * 60 * 1000, // 5分間キャッシュ
  })
}
